import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faUser } from "@fortawesome/free-regular-svg-icons";
import { Or } from "../../UI/preloading/PreloadState";
import { useHistory } from "react-router-dom";
import moment from "moment";

const SurveyRow = ({
  index,
  id,
  author,
  created_at,
  due_date,
  title,
  className,
}) => {
  const { role } = useSelector((state) => state.auth.user);
  const history = useHistory();

  return (
    <div
      style={{ background: index % 2 === 1 ? "#efefef" : "#fff" }}
      className={classNames(
        "notification border-top rounded-0",
        { "bg-200": "", "notification-flush": "" },
        className
      )}
    >
      <Row className="w-100">
        <Col>
          <div className="d-flex">
            <div className="notification-body">
              <Row className="justify-content-start align-items-center pl-3">
                <Col>
                  <h5 className="d-flex justify my-0 py-1">{title}</h5>
                  <div className="notification-time text-primary">
                    <FontAwesomeIcon icon={faUser} className="mr-1" />
                    {author === "me"
                      ? "Tú"
                      : `${author.firstname} ${author.lastname}`}
                  </div>
                  <div className="notification-time">
                    <FontAwesomeIcon icon={faClock} className="mr-1" />
                    <strong>Desde</strong>{" "}
                    {moment(created_at).format("DD/MM/YYYY")}
                    {!!due_date && (
                      <>
                        <strong>hasta</strong>{" "}
                        {moment(due_date).format("DD/MM/YYYY")}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col xs="auto" className="d-sm-flex align-items-center">
          <Or cond={role}>
            <Or value="manager">
              <UncontrolledDropdown
                direction="left"
                className="d-inline-block ml-2"
              >
                <DropdownToggle color="falcon-default" size="sm">
                  <FontAwesomeIcon icon="ellipsis-h" />
                </DropdownToggle>
                <DropdownMenu>
                  {new Date() >= new Date(due_date) && (
                    <DropdownItem
                      onClick={() =>
                        history.push(`/dashboard/surveys/preview/${id}`)
                      }
                    >
                      Ver respuestas
                    </DropdownItem>
                  )}
                  <DropdownItem
                    onClick={() =>
                      history.push(`/dashboard/surveys/edit/${id}`)
                    }
                  >
                    Editar
                  </DropdownItem>
                  <DropdownItem>Eliminar</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Or>
            <Or value="property">
              <UncontrolledDropdown
                direction="left"
                className="d-inline-block ml-2"
              >
                <DropdownToggle color="falcon-default" size="sm">
                  <FontAwesomeIcon icon="ellipsis-h" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() =>
                      history.push(`/dashboard/surveys/preview/${id}`)
                    }
                  >
                    Ver respuestas
                  </DropdownItem>
                  {new Date() <= new Date(due_date) && (
                    <DropdownItem
                      onClick={() => history.push(`/dashboard/surveys/${id}`)}
                    >
                      Contestar
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </Or>
          </Or>
        </Col>
      </Row>
    </div>
  );
};

SurveyRow.propTypes = {
  id: PropTypes.any.isRequired,
  interaction: PropTypes.object,
};

export default SurveyRow;
